<template>
  <div v-if="visible" class="modal-overlay" @click.self="emitClose">
    <div class="modal-content comparar-modal">
      <div class="close-button-container">
        <button class="close-button" @click="emitClose">×</button>
      </div>
      <h2>Comparar SKUs</h2>
      <div class="comparar-body">
        <div v-if="alertMessage" class="vue-alert">
          <span>{{ alertMessage }}</span>
          <button class="alert-close" @click="dismissAlert">×</button>
        </div>
        <div v-if="isLoading" class="spinner-cell">
          <div class="spinner"></div>
        </div>

        <div v-else>
          <div v-if="items && items.length">
            <div
              v-for="(c, index) in comparisons"
              :key="c.item.sku_id + '-' + index"
              class="comparison-block"
            >
              <h4>{{ c.item.sku_name || c.item.sku_id }}</h4>
              <div class="comparison-table-wrapper">
                <table class="comparison-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Actual</th>
                      <th>Histórico</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>SKU</th>
                      <td>{{ c.item.sku_id || '-' }}</td>
                      <td>{{ c.historico ? (c.historico.sku_id || '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Nombre</th>
                      <td>{{ c.item.sku_name || '-' }}</td>
                      <td>{{ c.historico ? (c.historico.sku_name || '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Estado</th>
                      <td>{{ c.item.estado || '-' }}</td>
                      <td>{{ c.historico ? (c.historico.estado || '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Distribuidor</th>
                      <td>{{ rfp.name_distribuidor || rfp.id_distribuidor || '-' }}</td>
                      <td>{{ c.historico ? (c.historico.name_distribuidor || c.historico.id_distribuidor || '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Planta</th>
                      <td>{{ rfp.planta != null ? rfp.planta : '-' }}</td>
                      <td>{{ c.historico ? (c.historico.planta != null ? c.historico.planta : '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Incoterm</th>
                      <td>{{ rfp.incoterm != null ? rfp.incoterm : '-' }}</td>
                      <td>{{ c.historico ? (c.historico.incoterm != null ? c.historico.incoterm : '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Invoice Mode</th>
                      <td>{{ rfp.invoice_mode != null ? rfp.invoice_mode : '-' }}</td>
                      <td>{{ c.historico ? (c.historico.invoice_mode != null ? c.historico.invoice_mode : '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Delivery</th>
                      <td>{{ rfp.delivery || '-' }}</td>
                      <td>{{ c.historico ? (c.historico.delivery || '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Precio USD / Kg</th>
                      <td>{{ c.item.precio_usd_kg != null ? c.item.precio_usd_kg : '-' }}</td>
                      <td>{{ c.historico ? (c.historico.precio_usd_kg != null ? c.historico.precio_usd_kg : '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Precio USD / Caja</th>
                      <td>{{ c.item.precio_usd_caja != null ? c.item.precio_usd_caja : '-' }}</td>
                      <td>{{ c.historico ? (c.historico.precio_usd_caja != null ? c.historico.precio_usd_caja : '-') : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Precio Usuario</th>
                      <td>{{ formatPrecioUsuario(c.item.precio_usuario) }}</td>
                      <td>{{ c.historico ? formatPrecioUsuario(c.historico.precio_usuario) : '-' }}</td>
                    </tr>
                    <tr>
                      <th>Fecha creación</th>
                      <td>{{ rfp.creation_date ? formatHistoricDate(rfp.creation_date) : '-' }}</td>
                      <td>{{ c.historico ? formatHistoricDate(c.historico.creation_date) : '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="!c.historico" class="no-historic">
                <p>No hay histórico para este SKU.</p>
              </div>
            </div>
          </div>
          <div v-else>
            <p>No hay items seleccionados.</p>
          </div>
        </div>

        <div style="text-align: right; margin-top: 1rem;">
          <button class="btn-close-modal" @click="emitClose">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert" />
</template>

<script>
import axios from 'axios';
import { formatPrecioUsuario } from '@/assets/js/priceFormat';

export default {
  name: 'CompararSkuModal',
  props: {
    visible: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    rfp: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      historicos: [],
      isLoading: false,
      alertMessage: ''
    };
  },
  computed: {
    comparisons() {
      const hs = this.historicos || [];
      return (this.items || []).map(item => {
        const skuId = String(item.sku_id || item.skuId || item.sku || item.id);
        const historico = hs.find(h => String(h.sku_id || h.skuId || h.sku || h.id) === skuId) || null;
        return { item, historico };
      });
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) this.fetchLastPrices();
    }
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    showAlert(type, title, message) {
        this.$refs.alert.showAlert(
            type,
            message,
            title,
            { 
                iconSize: 35,
                iconType: 'solid',
                position: 'top right' 
            } 
        )
    },
    formatPrecioUsuario,
    formatHistoricDate(dateStr) {
      if (!dateStr) return '-';
      try {
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (e) {
        return dateStr;
      }
    },
    async fetchLastPrices() {
      try {
        const skus = (this.items || []).map(i => String(i.sku_id || i.skuId || i.sku || i.id)).filter(Boolean);
        if (!skus.length) {
          this.historicos = [];
          return;
        }

        const maxSkus = 50;
        if (skus.length > maxSkus) {
          this.showAlert('warning', 'Atención', `Se han seleccionado ${skus.length} SKUs. Solo se mostrarán los últimos precios de los primeros ${maxSkus} SKUs.`);
          this.historicos = [];
          setTimeout(() => {
            this.emitClose();
          }, 2500);
          return;
        }
        
        const params = {
          skus: skus.join(','),
          planta: this.rfp?.planta
        };
        this.isLoading = true;
        const response = await axios.get('/pricing/lastPriceForSkus', { params });
        this.historicos = response.data.items || [];
      } catch (err) {
        console.error('Error fetching last prices for SKUs:', err);
        this.historicos = [];
        this.showAlert('error', 'Error', 'No se pudieron cargar los precios históricos. Intente nuevamente más tarde.');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
 

<style scoped>
.comparar-modal {
  max-width: 800px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}

.modal-content {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 8px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}
.comparison-table thead th {
  text-align: left;
  padding: 8px 10px;
  background: #f5f7fa;
}
.comparison-table th,
.comparison-table td {
  border: 1px solid #e8e8e8;
  padding: 8px 10px;
  text-align: left;
  vertical-align: middle;
}
.comparison-table tbody th {
  width: 200px;
  background: #fafafa;
}
.comparison-block {
  margin-bottom: 16px;
  padding: 10px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.no-historic {
  padding: 12px;
  background: #fff3cd;
  border-radius: 6px;
}

.btn-close-modal {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.08s ease, box-shadow 0.12s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.06);
}
.btn-close-modal:hover { background-color: #0056b3; }
.btn-close-modal:active { transform: translateY(1px); }

.vue-alert {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.alert-close {
  background: transparent;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: #721c24;
}



</style>

